const DUPLICATE_PATTERNS = [
  { key: 'phone_number_already_registered', re: /(no_hp|phone|mobile)/i },
  { key: 'bank_acc_already_registered', re: /(account_number|bank)/i },
];

const isAlreadyTaken = (message) => /(already|taken|exist|registered|duplicate|unique)/i.test(message);

export const getRegisterErrorMessage = (error, translate) => {
  const raw = error?.response?.data?.message || error?.message || '';

  if (isAlreadyTaken(raw)) {
    const match = DUPLICATE_PATTERNS.find(({ re }) => re.test(raw));
    if (match) return translate(match.key);
  }

  return translate(raw) || translate('network_error');
};

export const isOtpError = (message) => /otp|verification code/i.test(message || '');
